module.exports = __webpack_public_path__ + "img/278.e60b045f.png";